export default __webpack_public_path__ + "static/media/ame-title-gold.1a432e69.svg";